export default "__VITE_ASSET__CUvoXLFr__"